export default {
  PHOTO_ID: 1,
  SELFIE: 2,
  MEDICAL_CARD: 3,
  PRESCRIPTION: 4,
  LICENCE: 7
};
